import api from './axiosConfig';
export const listPublicBootcamps  = ()         => api.get('/api/public/bootcamps');
export const getPublicBootcamp    = (id)       => api.get(`/api/public/bootcamps/${id}`);
export const listBootcamps       = (params)   => api.get('/api/v1/bootcamps', { params });
export const getBootcamp         = (id)       => api.get(`/api/v1/bootcamps/${id}`);
export const createBootcamp      = (data)     => api.post('/api/v1/bootcamps', data);
export const updateBootcamp      = (id, data) => api.put(`/api/v1/bootcamps/${id}`, data);
export const deleteBootcamp      = (id)       => api.delete(`/api/v1/bootcamps/${id}`);
